import React, { Component } from "react";

import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

//Components
import SideBar from "../../components/Sidebar/Sidebar";
import Announcement from "./Announcement";
import Messages from "../MessageCenter/Messages";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import GaugeComponent from 'react-gauge-component'
import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import { isDesktop } from "react-device-detect";
import { getDashboard } from "../../store/ducks/dashboard/actions";
import Skeleton from "react-loading-skeleton";
import MobileDashboard from "./MobileDashboard";

const graphFilter = ['new-deposit', 'old-deposit', 'total-deposit', 'bet-amt', 'effective-amt', 'win-lose'];

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: {},
      options: {},
      chartTab: 0,
      chartType: 0,
      chartTypeLabel: "New Registered Deposit",
      loading: true,
      total_member: 0,
      first_deposit: 0,
      new_monthly_register: 0,
      new_daily_members: 0,
      active_monthly_member: 0,
      monthly_win_lose: 0,
      comm_rate: 0,
      total_days: 0,
      chartLastMonth: [],
      chartThisMonth: [],

      // Message Center
      activePanel: 0,
    };
  }

  componentDidMount(){
    this.fetchData(0, 0);
  }

  shouldComponentUpdate(nextProps, nextState){
    if(nextProps.dashboard_data !== undefined && nextProps.dashboard_data !== this.props.dashboard_data){
      if(nextProps.dashboard_data.responseCode === 200 && nextProps.dashboard_data.msgType === "success"){
        this.setState({
          loading: false,
          total_member: nextProps.dashboard_data.data.total_members,
          first_deposit: nextProps.dashboard_data.data.members_first_deposit,
          new_monthly_register: nextProps.dashboard_data.data.new_monthly_members,
          new_daily_members: nextProps.dashboard_data.data.new_daily_members,
          active_monthly_member: nextProps.dashboard_data.data.active_monthly_members,
          monthly_win_lose: nextProps.dashboard_data.data.monthly_win_lose,
          comm_rate: nextProps.dashboard_data.data.commission_rate,
          total_days: nextProps.dashboard_data.data.total_days,
          chartLastMonth: nextProps.dashboard_data.data.filtered_chart_last_month,
          chartThisMonth: nextProps.dashboard_data.data.filtered_chart_this_month
        });
      }
    }
    return true;
  }

  fetchData = (type = null, graph = null) => {
    let data = {};
    data.type = type === 0 ? 'amount' : 'headcount';
    data.graph = graphFilter[graph];
    this.props.getDashboard(data);
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  chartTabHandler = (tab) => {
    this.setState({
      chartTab: tab,
      chartType: 0,
      loading: true
    }, this.fetchData(tab, 0));
  };

  chartTypeHandler = (i, label) => {
    this.setState({
      chartType: i,
      chartTypeLabel: label,
      loading: true
    }, this.fetchData(this.state.chartTab, i));
  };

  showInfoHandler = (e) => {
    const { t } = this.props;
    e.preventDefault();
    const swalIcon = this.imageImport(require.context("../../assets/images/swal", false, /\.(png|jpe?g|svg|webp)$/));

    Swal.fire({
      iconHtml: "<img src=" + swalIcon["notify.webp"] + "/>",
      // iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">' : '',
      title: t("global.reminder"),
      html: t("validation.detect-30min"),
      confirmButtonText: t("global.ok"),
      // customClass: {
      //   popup: "mw-100",
      //   confirmButton: "w-50",
      //   icon: 'no-border'
      // },
      customClass: (!isDesktop) ? {
        container: "swal-mobile-container reminder",
        icon: "swal-reminder-icon",
    } : [],
    }).then((result) => {
      if (result.isConfirmed) {
      }
    });
  }

  //Message Center
  handleActivaPanel = (panel) => {
    this.setState({
      activePanel: panel,
    });
  };

  handleChangePage = (event, page, val, data, type, status, activePage) => {
    this.setState({
      pageShow: page,
      currentId: val,
      data: data,
      msgType: type,
      msgStatus: status,
      activePage: activePage,
    });
  };

  handleGraph = () => {
    let data = [];
    const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
    if(this.state.total_days > 0){
      for(let i = 1; i <= this.state.total_days; i++){
        let lmonth = this.state.chartLastMonth[i] ? parseFloat(new Intl.NumberFormat("en-US", num_format).format(this.state.chartLastMonth[i])) : 0;
        let tmonth = this.state.chartThisMonth[i] ? parseFloat(new Intl.NumberFormat("en-US", num_format).format(this.state.chartThisMonth[i])) : 0;
        data.push({ day: i, LMonth: lmonth, TMonth: tmonth });
      }
    }
    return data;
  }

  render() {
    const { t } = this.props;
    const icon = this.imageImport(require.context("../../assets/images/dashboard", false, /\.(png|jpe?g|svg|webp)$/));
    const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

    const widgetsArr = [
      { value: this.state.total_member, label: t("dashboard.total-member"), img: "total-members.webp" },
      { value: this.state.first_deposit, label: t("dashboard.first-deposit"), img: "first-depositers.webp" },
      { value: this.state.new_monthly_register, label: t("dashboard.new-monthly-register"), img: "new-registrars.webp" },
      { value: this.state.new_daily_members, label: t("dashboard.new-member"), img: "new-members.webp" },
      { value: this.state.active_monthly_member, label: t("dashboard.active-monthly-member"), img: "active-members.webp" },
      { value: new Intl.NumberFormat("en-US", num_format).format(this.state.monthly_win_lose), label: t("dashboard.monthly-win-lose") + " (USD)", img: "net-win.webp" }
    ];

    const chartTypesOne = [
      { id: 1, label: t("dashboard.new-deposit") },
      { id: 2, label: t("dashboard.old-deposit")},
      // { id: 3, label: "First Deposit" },
      { id: 3, label: t("dashboard.total-deposit") },
      { id: 4, label:t("dashboard.bet-amount") },
      { id: 5, label: t("dashboard.effective-amount") },
      { id: 6, label: t("dashboard.win-lose") }
    ];

    const chartTypesTwo = [
      { id: 1, label: t("dashboard.new-deposit") },
      { id: 2, label: t("dashboard.old-deposit") }
      // { id: 3, label: "First Deposit" },
    ];

    const chartData = this.handleGraph();

    const slateGray = "#8b9ccb"

    const fadeUp = keyframes`
    from {
      opacity: 0;
      transform: translate3d(0, 50px ,0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  `;

    let lastMonthLabel = t('dashboard.last-month');
    let thisMonthLabel = t('dashboard.this-month');
    if(this.state.chartTab === 0){
      lastMonthLabel += ' (USD)';
      thisMonthLabel += ' (USD)';
    }

    return (
      <Auxiliary>
        { isDesktop ? (
          <>
            <section className="pf-dashboard">
              <div className="x-container">
                <SideBar />
                <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                  <div className="row">
                    <div className="db-col col-12">
                    {this.state.loading ? <Skeleton count={1} height={200} /> :
                    <>
                      <div className="row g-2">
                        {widgetsArr && widgetsArr.map((item, index) => (
                          // <div className="x-col-1-5" key={index}>
                            <div className="col-2" key={index}>
                            <div className="db-tp-panels">
                              <img src={icon[`${item.img}`]} alt={item.label} />
                              <h4>{item.value}</h4>
                              <p>{item.label}</p>
                            </div>
                          </div>
                        ))}
                        {/* <div className="x-col-3">
                          <div className="db-tp-panels">
                            <GaugeComponent
                              // type="radial"
                              style={{width: "125%"}}
                              labels={{
                                tickLabels: {
                                  type: "outer",
                                  ticks: [
                                    { value: 20 },
                                    { value: 40 },
                                    { value: 60 },
                                    { value: 80 },
                                    { value: 100 },
                                  ]
                                },
                                defaultTickLineConfig:[{hide: true}]
                              }}
                              arc={{
                                colorArray: ['#f6faff','#4a89fc'],
                                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                                width: 0.25
                              }}
                              value={80}
                              pointer={{type: "arrow", elastic: true}}
                            />
                          </div>
                        </div> */}
                      </div>
                      <div className="pd-card-col">
                        <h4>{t("dashboard.data-compare")}</h4>
                        <div className="pd-content">
                          <div className="db-chart-header">
                            <button
                              type="button"
                              className={`btn-blue-bg ${this.state.chartTab === 0 ? "active" : ""}`}
                              onClick={() => this.chartTabHandler(0)}
                            >
                              <p>{t("dashboard.amount")}</p>
                            </button>
                            <button
                              type="button"
                              className={`btn-blue-bg ${this.state.chartTab === 1 ? "active" : ""}`}
                              onClick={() => this.chartTabHandler(1)}
                            >
                              <p>{t("dashboard.no-people")}</p>
                            </button>
                            <Icon className="btn-info" icon="mdi:information" onClick={(e) => this.showInfoHandler(e)} />
                          </div>
                          <ResponsiveContainer width="100%" height={350}>
                            <LineChart
                              width={500}
                              height={300}
                              data={chartData}
                              margin={{
                                top: 15,
                                left: 15,
                                right: 15,
                              }}
                            >
                              <XAxis dataKey="day" type="number" domain={[1, 31]} tickCount={31} tickSize={5} tickLine={false} axisLine={{ stroke: slateGray }} label={{ fill: slateGray }} />
                              <Tooltip labelFormatter={() => this.state.chartTypeLabel} cursor={{ stroke: '#F6FAFF', strokeWidth: 20 }} wrapperStyle={{ outline: "none" }} />
                              <Legend />
                              <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="LMonth" name={lastMonthLabel} stroke="#4A89FC" />
                              <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="TMonth" name={thisMonthLabel} stroke="#04BE02" />
                            </LineChart>
                          </ResponsiveContainer>
                          <div className="db-chart-footer">
                            {this.state.chartTab === 0 ?
                              chartTypesOne &&
                              chartTypesOne.map((item, index) => (
                                <button
                                  type="button"
                                  key={index}
                                  className={`${this.state.chartType === index ? "active" : ""}`}
                                  onClick={() => this.chartTypeHandler(index, item.label)}
                                >
                                  <p>{item.label}</p>
                                </button>
                              )) : this.state.chartTab === 1 ?
                                chartTypesTwo &&
                                chartTypesTwo.map((item, index) => (
                                  <button
                                    type="button"
                                    key={index}
                                    className={`${this.state.chartType === index ? "active" : ""}`}
                                    onClick={() => this.chartTypeHandler(index, item.label)}
                                  >
                                    <p>{item.label}</p>
                                  </button>
                                )) : <></>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="pd-card-col">
                        <Messages from_dashboard={true} />
                      </div>
                    </>
                    }
                    </div>
                  </div>
                </Reveal>
              </div>
            </section>
          </>
        ) : (
          <>
          <MobileDashboard 
              {...this.state}
              {...this.props}
              widgetsArr ={widgetsArr}
              chartTypesOne={chartTypesOne}
              chartTypesTwo={chartTypesTwo}
              showInfoHandler={this.showInfoHandler}

          />
        </>
        )}
      </Auxiliary>
    );
  }
}

const mapStateToProps = state => {
  return {
    dashboard_data: state.dashboard.dashboard_data
  }
}

const mapDispatchToProps = {
  getDashboard
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(Dashboard));
